export type Branch = {
  id: number
  companyId: number
  name: string
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
  company: Company
  count?: number
  hash?: string,
  type?: number
}

export enum CompanyType {
  MANAGEMENT = "MANAGEMENT",
  AGENT = "AGENT",
  BUSINESS = "BUSINESS",
  OWNER_AGENCY = "OWNER_AGENCY",
  COLLECTION_AGENCY = "COLLECTION_AGENCY",
  CORPORATE_HOUSING = "CORPORATE_HOUSING",
  FUND = "FUND",
}

export type Company = {
  id: number
  type: CompanyType
  code: string
  name: string
  kana: string
  licensingProvince: string
  licenseNo: number
  branches: Branch[]
  createdAt: string
  updatedAt: string
  deletedAt: Date | null
  email: string
  isNoFormSign: 1 | 0
}

export interface BusinessCompany extends Company {
  password: string
  hash: string
  forImport: number
  managerId: any
}

export interface OtherAccount {
  type?: string
  name?: string
  kana?: string
  email?: string
  code?: string
  password?: string
  enable?: string
  sendEmail?: string
}
